import store from "../store";

export const createRequestOptions = (body) => {
  let formData = new FormData();
  
  const authStore = store.getState().auth;
  const token = authStore.token;
  const refreshToken = authStore.refreshToken;

  formData.append("req", JSON.stringify(body));
  let options = {
    headers: {
      Authorization: "Bearer " + token,
      XACRT: refreshToken,
    },
    method: "post",
  };
  options.body = formData;

  return options;
};

export const getUserActivityCustomAppIdValueFromStore = () => {
  return store.getState().userActivity.customAppId;
};

export const getUserActivityCurrentSessionValueFromStore = () => {
  return store.getState().userActivity.currentSession;
};



// WEBPACK FOOTER //
// ./src/services/utils.js